<div
  *renderingPermissionDirective="[
    'FirmwareAdmin',
    'FirmwareReader',
    'FirmwareWriter',
    'ModuleUpdateAdmin',
    'ModuleUpdateReader',
    'ModuleUpdateWriter',
  ]"
  class="firmware-details">
  <div class="firmware-details__content">
    <dcc-back-button></dcc-back-button>
    <dcc-page-title title="Versions"></dcc-page-title>

    <div class="firmware-details__container">
      <dcc-module-card-display
        [editable]="false"
        [module]="this.module"></dcc-module-card-display>

      <div class="firmware-details__actions">
        <dcc-billboard
          label="Versions"
          [value]="numberOfFirmwareVersions | number"></dcc-billboard>
        <button
          class="lx-btn-small lx-btn-primary"
          (click)="onFirmwareVersionCreateClick()">
          Add Version
        </button>
      </div>

      <ag-grid-angular
        class="ag-theme-alpine ag-grid-sticky-header"
        domLayout="autoHeight"
        style="width: 100%; height: 100%"
        [columnDefs]="columnDefs"
        [defaultColDef]="defaultColDef"
        [enableCellTextSelection]="true"
        [ensureDomOrder]="true"
        [suppressRowHoverHighlight]="true"
        (gridReady)="onGridReady($event)"></ag-grid-angular>
    </div>
  </div>
</div>
